import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/links-cleanup")({
  component: lazyRouteComponent(() => import("./-pages/admin.links-cleanup")),
  head: () => ({
    meta: [
      { title: "تنظيف الروابط اليتيمة — Lecmo Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
});
